import $ from 'jquery';

// import CCAShareCheckbox from '@/components/form/CCAShareCheckbox.vue';

export default {
    name: 'manage-motif',
    // components: { CCAShareCheckbox },
    props: {
        consultation_id: Number,
        evolution_id: Number,
        group_id: Number,
        user_id: Number,
        data_to_be_deleted: Object
    },
    data() {
        return {
            save_loading: false,
            is_error: false,
            permission_is_denied: false,

            motif_histoire: {
                motif: null,
                histoire: null
            },

            filtered_motif: [],
            value: '',
            motifs: [
                {
                    id: 0,
                    motif: ''
                }
            ],
            motif_selected: [],
            del_loading: false,
            is_confirm: false,
            
            tmp_motifs: [],   // Motif tempon à l'ajout
            choice_is_empty: false,
        }
    },

    watch: {
        group_id() {
            this.permission_is_denied = false
            this.tmp_motifs = []
            this.choice_is_empty = false
            this.is_error = false
        }
    },

    computed: {
        liste_motifs() {
            return this.$store.getters["liste_motifs"];
        },
    },

    mounted() {
        this.refreshListeDesMotifs()
    },

    methods: {
        refreshListeDesMotifs() {
            this.$store.dispatch("getListeMotifs")
        },

        filterMotifs() {
            this.choice_is_empty = false
            this.filtered_motif = [];
            if (this.value.length >= 2) {
                this.liste_motifs.forEach(
                    element => {
                        if (element.libelle.toLowerCase().includes(this.value.toLowerCase())) {
                            this.filtered_motif.push(element)
                        }
                    }
                )
            }
        },

        addExistingMotif(data) {
            let j = 0
            let len = this.tmp_motifs.length

            let tmp_motif = {}
            this.liste_motifs.forEach(function (el) {
                if (data.libelle == el.libelle) {
                    tmp_motif = {
                        id: el.id,
                        motif: el.libelle
                    }
                }
            });

            // Verifier si motif déjà choisi
            if (len > 0) {
                for (let i = 0; i < this.tmp_motifs.length; i++) {
                    if (data.libelle == this.tmp_motifs[i].motif) {
                        j++;
                    }
                }
            }
            if (j == 0) {
                this.tmp_motifs.push(tmp_motif);

                this.value = ''

            }
            this.filtered_motif = []
        },

        /**
         * Ajoute un nouveau motif
         * @param {} index 
         */
        addNewMotif() {
            let j = 0
            let len = this.tmp_motifs.length

            let tmp_motif = {
                id: 0,
                motif: this.value
            }

            // Verifier si motif déjà choisi
            if (len > 0) {
                for (let i = 0; i < this.tmp_motifs.length; i++) {
                    if (this.value == this.tmp_motifs[i].motif) {
                        j++;
                    }
                }
            }
            if (j == 0) {
                this.tmp_motifs.push(tmp_motif);

                this.value = ''
                this.filtered_motif = []
            }
        },

        saveMotif() {
            this.choice_is_empty = false
            this.permission_is_denied = false
            this.is_error = false
            if (this.tmp_motifs.length == 0) {
                this.choice_is_empty = true
                return
            }

            let motif_data = {
                user_id: this.user_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                group_id: this.group_id,
                motifs: this.tmp_motifs
            }

            this.save_loading = true

            this.$store.dispatch('saveConsultationMotif', motif_data).then((response) => {
                
                if (response > 0) {
                    this.tmp_motifs = []
                    this.$emit("emitMotifConsultation")
                    this.refreshListeDesMotifs()

                    this.$refs.motif_mdl.click()
                } else {
                    if (response === -1) {
                        this.is_error = true
                    } else if (response === -2) {
                        this.permission_is_denied = true
                    }
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        removeTmp(index) {
            this.tmp_motifs.splice(index, 1)
        },

        /**
         * Retirer Diagnostic/Hypothèse diagnostique
         */

        supprimer(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            this.$store.dispatch('removeConsultationMotif', this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Motif retiré avec succès')
                    this.$emit("emitMotifConsultation")

                    this.$refs.del_motif.click()
                } else if (response === -2) {
                    this.permission_is_denied = true
                }

                
                this.del_loading = false;
                this.is_confirm = false
                this.btn_disable = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        },

        supprimerGroupMotif(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            this.$store.dispatch('removeConsultationGroupMotif', this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Groupe de Motif retiré avec succès')
                    this.$emit("emitMotifConsultation")

                    this.$refs.del_grp_motif.click()
                } else if (response === -2) {
                    this.permission_is_denied = true
                }

                
                this.del_loading = false;
                this.is_confirm = false
                this.btn_disable = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        }
    }
}


